import { render } from "./resetPasswordPage.vue?vue&type=template&id=6dbdf7fd&scoped=true"
import script from "./resetPasswordPage.vue?vue&type=script&lang=js"
export * from "./resetPasswordPage.vue?vue&type=script&lang=js"

import "./resetPasswordPage.vue?vue&type=style&index=0&id=6dbdf7fd&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dbdf7fd"]])

export default __exports__